import { openBlock as t, createElementBlock as o, createElementVNode as n } from "vue";
const r = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
};
function l(m, e) {
  return t(), o("svg", r, [...e[0] || (e[0] = [
    n("path", {
      fill: "currentColor",
      d: "M20.667 20H4V4h16.667zm-16-.667h4.666v-4H4.667zm10.666 0H20v-4h-4.667zm-5.333 0h4.667v-4H10zm-5.333-4.666h4.666V10H4.667zm10.666 0H20V10h-4.667zm-5.333 0h4.667V10H10zM4.667 9.333h4.666V4.667H4.667zm10.666 0H20V4.667h-4.667zm-5.333 0h4.667V4.667H10z"
    }, null, -1)
  ])]);
}
const z = { render: l };
export {
  z as default,
  l as render
};
